/* PDP polish behaviour (Claude Opus 5.5, 2026-09-24).
   Tier card art follows the per-unit color rows: unit N in the selected tier card shows
   the color chosen in Color #N; unselected cards stay Black (Zack, 2026-09-25). Loaded after pm-product-offer.min.js, reads the same
   radios the cart logic reads, and never touches cart state. */
(() => {
  const syncUnitArt = (offer) => {
    const rows = [...offer.querySelectorAll('[data-pm-color-row]')];
    const colors = rows.map((row) => {
      const checked = row.querySelector('[data-pm-color]:checked');
      return String(checked?.value || 'Black').toLowerCase();
    });
    // Only the selected tier card previews the chosen colors; the others stay Black.
    const selected = offer.querySelector('[data-pm-tier]:checked')?.closest('[data-pm-tier-card]');
    offer.querySelectorAll('img[data-pm-unit]').forEach((img) => {
      const inSelected = selected && selected.contains(img);
      const color = inSelected ? (colors[Number(img.dataset.pmUnit) - 1] || 'black') : 'black';
      const src = color === 'white' ? img.dataset.pmSrcWhite : img.dataset.pmSrcBlack;
      if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.dataset.pmUnitColor = color;
    });
  };

  const init = () => {
    document.querySelectorAll('pm-product-offer').forEach((offer) => {
      if (offer.dataset.pmUnitArt === 'ready') return;
      offer.dataset.pmUnitArt = 'ready';
      syncUnitArt(offer);
      offer.addEventListener('change', (event) => {
        if (event.target?.matches?.('[data-pm-color], [data-pm-tier]')) syncUnitArt(offer);
      });
      const white = offer.querySelector('img[data-pm-src-white]')?.dataset.pmSrcWhite;
      if (white) {
        const warm = () => { const img = new Image(); img.decoding = 'async'; img.src = white; };
        if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 });
        else setTimeout(warm, 1500);
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Filter box: ticking "Add extra filters" opens More Filter Information so the three
   checkmark notes show with the quantity chips; unticking folds it away (Zack, 2026-09-25). */
(() => {
  const bind = () => {
    document.querySelectorAll('pm-product-offer .pk-filter').forEach((shell) => {
      if (shell.dataset.pmFilterAutoOpen === 'ready') return;
      shell.dataset.pmFilterAutoOpen = 'ready';
      const box = shell.querySelector('[data-pm-filter]');
      const more = shell.querySelector('[data-pm-filter-more]');
      const details = shell.querySelector('[data-pm-filter-details]');
      if (!box || !more || !details) return;
      box.addEventListener('change', () => {
        more.setAttribute('aria-expanded', String(box.checked));
        details.hidden = !box.checked;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();

/* 5 Reasons pagination: the active dot follows the swipe rail; tapping a dot scrolls to it. */
(() => {
  const bind = () => {
    document.querySelectorAll('.pm-five-reasons').forEach((section) => {
      const rail = section.querySelector('.pm-five-reasons__viewport');
      const dots = [...section.querySelectorAll('[data-pm-reasons-dot]')];
      const slides = [...section.querySelectorAll('.pm-five-reasons__slide')];
      if (!rail || !dots.length || slides.length < 2 || section.dataset.pmDotsReady === 'true') return;
      section.dataset.pmDotsReady = 'true';
      const step = () => slides[1].offsetLeft - slides[0].offsetLeft || rail.clientWidth;
      const sync = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        const index = rail.scrollLeft >= max - 2 ? slides.length - 1 : Math.round(rail.scrollLeft / step());
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      };
      let frame = 0;
      rail.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(sync);
      }, { passive: true });
      dots.forEach((dot, i) => dot.addEventListener('click', () => {
        const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
        rail.scrollTo({ left: i * step(), behavior: smooth ? 'smooth' : 'auto' });
      }));
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();


/* How It Works: seamless loop (Zack, 2026-09-25: "flashing once it loops"). The clip's
   first and last frames match, but the native loop restart presents a blank frame on some
   browsers. Just before the end, seek back to the start ourselves, skipping the restart
   frame. Play/pause stays with pm-pdp-original-motion. */
(() => {
  const START = 0.04;
  const TAIL = 0.12;
  const bind = () => {
    document.querySelectorAll('.pm-how-it-works__media video').forEach((video) => {
      if (video.dataset.pkSeamless === 'ready' || !('requestVideoFrameCallback' in HTMLVideoElement.prototype)) return;
      video.dataset.pkSeamless = 'ready';
      video.loop = false;
      const tick = (now, meta) => {
        const duration = video.duration;
        if (Number.isFinite(duration) && duration > 1 && meta.mediaTime >= duration - TAIL) video.currentTime = START;
        video.requestVideoFrameCallback(tick);
      };
      video.requestVideoFrameCallback(tick);
      video.addEventListener('ended', () => {
        video.currentTime = START;
        Promise.resolve(video.play()).catch(() => {});
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
